module.exports = __webpack_public_path__ + "static/media/tutorial-dr-licita-document-keyword.dd9e3b82.png";